<app-test title="Prüfungssimulation {{ test.expand.conditions.name }}">
    <ng-container slot="progress">
        <div class="bg-background-dark w-full rounded-xl shadow-sm overflow-hidden mr-8">
            <div class="relative h-4 flex items-center justify-center">
                <div #progressbar class="absolute top-0 bottom-0 left-0 rounded-lg bg-blue"></div>
            </div>
        </div>
        <span class="notranslate">{{ remainingSeconds | timer }}</span>
    </ng-container>

    @if(test){
    <app-question slot="question" [orderSeed]="orderSeed" [index]="currentQuestionIndex + 1"
        [total]="test.questions.length" [question]="test.expand.questions[currentQuestionIndex]"
        (answersSelected)="handleAnswersSelected($event)" [existingAnswers]="currentAnswers"
        (questionFlagged)="handleQuestionFlagged(currentQuestionIndex, $event)"
        [flagged]="isQuestionFlagged(currentQuestionIndex)" [disabled]="remainingSeconds <= 0"></app-question>
    }

    @if(test){
    <ng-container slot="buttons">
            @if (currentQuestionIndex === 0) {
                <button class="invisible white-button">Zurück</button>
            } @else {
                <button class="z-10 white-button" (click)="setQuestionIndex(currentQuestionIndex - 1)">Zurück</button>
            }
        <div class="flex flex-row items-center gap-2">
            <button class="z-10 white-button flex items-center gap-2 cursor-pointer" (click)="handleAbortClicked()">
                <ng-icon name="faSolidXmark"></ng-icon>
                <span class="hidden sm:inline">Abbrechen</span>
            </button>
            <button class="z-10 white-button flex items-center gap-2 cursor-pointer" (click)="toggleQuestionOverview()">
                <ng-icon name="faSolidList"></ng-icon>
                <span class="hidden sm:inline">Fragenübersicht</span>
            </button>
        </div>
            
        @if (currentQuestionIndex === test.questions.length - 1) {
        <button class="z-10 orange-button" (click)="submit()">Beenden</button>
        } @else if(canProceed){
        <button class="z-10 blue-button" (click)="setQuestionIndex(currentQuestionIndex + 1)">Weiter</button>
        } @else {
        <button class="z-10 white-button cursor-not-allowed">Weiter</button>
        }
    </ng-container>
    }
</app-test>

<app-modal #questionOverviewModal>
    <app-question-overview (toggleModal)="toggleQuestionOverview()" [questions]="test.expand.questions"
        [flaggedQuestions]="flaggedQuestions" (questionFlagged)="handleQuestionFlaggedId($event)"
        (questionSelected)="setQuestionIndex($event)" [answers]="answers">
    </app-question-overview>
</app-modal>

<app-modal #submitModal>
    <div class="flex flex-row items-center w-full h-full">
        <div class="flex flex-col items-center w-full text-center">
            @if (remainingSeconds > 0) {
            <img src="./assets/img/submit-modal-penguin.png" alt="Überprüfung der Ergebnisse"
                class="w-40 h-40 rounded-full" />
            <h3 class="pt-6 pb-4">Deine Ergebnisse werden geprüft</h3>
            } @else {
            <img src="./assets/img/penguin-time-expired.jpg" alt="Zeit abgelaufen" class="w-40 h-40 rounded-full" />
            <h3 class="pt-6 pb-4">Ups, die Zeit ist abgelaufen</h3>
            }
            <p class="px-20 text-center">Wir leiten dich umgehend auf die Übersichtsseite weiter.</p>
        </div>
    </div>
</app-modal>

<app-modal #abortModal>
    <div class="flex flex-row items-center w-full h-full">
        <div class="flex flex-col items-center w-full text-center">
            <h3 class="pt-6 pb-4">Bist du sicher?</h3>
            <p class="px-20 text-center">Wenn du die Prüfungssimulation jetzt abbrichst, werden alle unbeantworteten
                Fragen als "falsch" gewertet.</p>
            <div class="flex flex-row justify-between gap-4 mt-6">
                <button class="blue-button" (click)="abortModal.toggleModal()">Nein, ich möchte weiter machen</button>
                <button class="orange-button" (click)="abort()">Ja, Prüfung jetzt abbrechen</button>
            </div>
        </div>
    </div>
</app-modal>